import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import RelativeLink from "../common/RelativeLink";
import TabNavIcon from "../common/TabNavIcon";
import { Popup } from 'semantic-ui-react';

const TabNavItem = ({ color, iconType, disabled, display, to, visible, showTooltip, hideText }) => {
	const colorText = color ? color : "blue";
	const navItemClassName = {
		"c-anchor-nav__item": true,
		["item--" + colorText]: true,
		"c-anchor-nav__item--disabled": disabled
	};
	const displayText = hideText ? "" : (<p style={{wordBreak:'break-word'}}>{display}</p>);

	const relativeLink =
		(visible ? <div>
			{!disabled ? <RelativeLink to={to} className="ui-tab">
				<TabNavIcon type={iconType} color={colorText} />{displayText}
			</RelativeLink> :
				<span><TabNavIcon type={iconType} color={colorText} />{displayText}</span>}
		</div> : null);

	return (<div className={classnames(navItemClassName)}>
		<Popup trigger={relativeLink} content={display} />
	</div>);

};

TabNavItem.propTypes = {
	display: PropTypes.string.isRequired,
	to: PropTypes.string.isRequired,
	color: PropTypes.string,
	iconType: PropTypes.string,
	disabled: PropTypes.bool,
	visible: PropTypes.bool,
	showTooltip: PropTypes.bool,
	hideText: PropTypes.bool
};

export default TabNavItem;